import FacturacionTab from './FacturacionTab'
import './FacturacionTab.css'

export default FacturacionTab